import selectors from '../globals/selectors';
import scrollToTop from '../helpers/scrollToTop';

export default () => {
	const btnEl = document.querySelector(selectors.scrollToTop.element);
    if (btnEl === null)
        return;
	btnEl.addEventListener('click', (ev) => {
		ev.preventDefault();
		scrollToTop();
	});
};
